import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Grid, Divider } from "semantic-ui-react";
import PageHeader from "../../../app/layout/PageHeader";
import ImportLogs from "../ImportLogs";

export default observer(function CarfaxNightly() {
  const { t } = useTranslation(["common", "systemAdmin"]);

  return (
    <>
      <Grid stackable>
        <Grid.Row>
          <Grid.Column>
            <PageHeader
              type="h1"
              header={t('logs.imports_intro', {ns: 'systemAdmin'})}
              className="modal-text-color"
              textAlign="left"
              divider={false}
              addTitle
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider />
      <Grid stackable>
        <Grid.Column stackable>
          <ImportLogs />
        </Grid.Column>
      </Grid>
    </>
  );
});